<!--
  ~ Copyright (C) 2019 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div
  [hidden]="hidePreview"
  [attr.role]="!hidePreview ? 'group' : null"
  [attr.aria-label]="!hidePreview ? ('translations.global.label.preview' | transloco) : null"
  [tabindex]="!hidePreview ? 0 : -1"
  class="preview-element
    preview-element-type-{{ content?.type }}
    preview-element-position-{{ content?.position || 'CENTER' }}
    {{ containerClass }}"
  #htmlEl
></div>

<button *ngIf="shouldShowSeeMore" class="see-more-button" type="button" (click)="toggleExpansion($event)">
  {{ 'translations.global.button.showMore' | transloco }}
</button>
